import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import CurrenciesService from "../../api/currencies";


export const getCurrencies = createAsyncThunk(
  "currencies/get",
  async (args, thunkAPI) => {
    try {
      const response = await CurrenciesService.getCurrencies(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = [];

const currenciesSlice = createSlice({
  name: "currencies",
  initialState,
  extraReducers: {
    [getCurrencies.fulfilled]: (state, action) => {
      let currencies = action.payload;
      const isk = currencies.findIndex((currency) => currency.code === 'ISK')
      let iskObj = currencies[isk]
      if (isk > -1) {
        currencies.splice(isk, 1)
        currencies.unshift(iskObj)
      }

      Object.assign(state, currencies);
    },
    [getCurrencies.rejected]: (state, action) => {
      state.error = gettext("Could not fetch currencies");
    },
   
  },
});

const { reducer } = currenciesSlice;
export default reducer;